import wcShared from '@web-components/shared';

export function getCurrentTheme(): 'dark' | 'light' {
  return wcShared?.store?.theme || 'light';
}

export function setupTheme(component: { theme: 'dark' | 'light' }) {
  component.theme = getCurrentTheme();

  const handler = (value: 'dark' | 'light') => {
    component.theme = value;
  };

  wcShared?.store?.addObserver('theme', handler);

  return () => wcShared?.store?.removeObserver('theme', handler);
}
